import React from 'react';

/* ====================================================================
   SETUP SCREEN — first-run admin account creation
   ==================================================================== */
function SetupScreen({ onSetup }) {
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [clubName, setClubName] = React.useState('');
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await onSetup(name, email, password, clubName);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f5f5f5' }}>
      <div className="w3-card w3-round w3-white" style={{ maxWidth: '450px', width: '100%', margin: '16px' }}>
        <div className="w3-container w3-theme-d4 w3-round-top" style={{ padding: '20px 24px' }}>
          <h3 style={{ margin: 0 }}><i className="fa fa-cog w3-margin-right"></i>Welcome — First Time Setup</h3>
          <p style={{ margin: '4px 0 0', opacity: 0.8, fontSize: 'var(--gs-text-sm)' }}>Create the super admin account and your club to get started</p>
        </div>
        <form onSubmit={handleSubmit} className="w3-container w3-padding-24">
          {error && <div className="w3-panel w3-red w3-round w3-padding-small"><small>{error}</small></div>}
          <label className="w3-small w3-text-grey">Club Name</label>
          <input className="w3-input w3-border w3-round w3-margin-bottom" required value={clubName}
            onChange={e => setClubName(e.target.value)} placeholder="e.g. Wellington Bowls Club" />
          <label className="w3-small w3-text-grey">Your Full Name</label>
          <input className="w3-input w3-border w3-round w3-margin-bottom" required value={name}
            onChange={e => setName(e.target.value)} placeholder="e.g. John Smith" />
          <label className="w3-small w3-text-grey">Email</label>
          <input className="w3-input w3-border w3-round w3-margin-bottom" type="email" required value={email}
            onChange={e => setEmail(e.target.value)} placeholder="admin@club.co.nz" />
          <label className="w3-small w3-text-grey">Password</label>
          <input className="w3-input w3-border w3-round w3-margin-bottom" type="password" required minLength={8} autoComplete="new-password"
            value={password} onChange={e => setPassword(e.target.value)} placeholder="At least 8 characters" />
          <button className="w3-button w3-theme w3-round w3-block w3-margin-top" type="submit" disabled={loading}>
            {loading ? <i className="fa fa-spinner fa-spin"></i> : <><i className="fa fa-rocket w3-margin-right"></i>Create Club & Admin Account</>}
          </button>
        </form>
      </div>
    </div>
  );
}

export default SetupScreen;
